<ion-grid class="ion-justify-content-start">
  <ion-row>
    <ion-col
      [size]="columnCount"
      [sizeMd]="columnCount"
      *ngFor="let item of node?.items; let index = index">
      <ion-card>
        <div [ngClass]="{ 'ion-card-content-wrapper': columnCount === 12 }">
          <div
            class="ion-card-img"
            [ngClass]="{ 'ion-card-img-right': item.placement === 'right' }">
            <app-img-format
              *ngIf="item.img?.url"
              [src]="item.img?.url"
              [aspectRatio]="'16:9'"
              [disableLazyLoad]="true"></app-img-format>
          </div>
          <div
            class="ion-card-text"
            [ngClass]="{
              'ion-card-text-left': item.placement === 'right',
              'ion-card-text-grid': columnCount !== 12
            }">
            <ion-card-header>
              <ion-card-subtitle
                [innerHTML]="item.sub_title"></ion-card-subtitle>
              <ion-card-title [innerHTML]="item.title"></ion-card-title>
            </ion-card-header>
            <ion-card-content [innerHTML]="item.description"></ion-card-content>
            <app-button
              *ngIf="item?.button_text"
              [icon]="{ name: 'arrow-right', position: 'right' }" 
              position="left"
              (click)="buttonLink()">
              {{ item.button_text }}
            </app-button>
          </div>
        </div>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>
